import { Component } from 'vue-property-decorator';


import { Type } from "src/utils";

/**
 * 表示一个菜单打开方式。
 * @enum
 * @version 1.0.0
 */
enum OpenType
{
    /**
     * 无。
     * @member
     */
    none = 0,

    /**
     * 组件
     * @member
     */
    component = 1,

    /**
     * 内链
     * @member
     */
    internal = 2,

    /**
     * 外链
     * @member
     */
    external = 3
}

/*
* 定义枚举元数据。
*/
Type.setMetadata(OpenType,
{
    none:
    {
        alias: "无",
        description: ""
    },
    component:
    {
        alias: "组件",
        description: ""
    },
    internal:
    {
        alias: "内链",
        description: ""
    },
    external:
    {
        alias: "外链",
        description: ""
    }
});

export default OpenType;
